var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDollyRojo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "34px",
    viewBox: "0 0 147 34",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "D2D68C17-3E77-4293-912C-011CF7AF5808")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inicio",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inicio_dollies",
    transform: "translate(-1047.000000, -669.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "second_bar",
    transform: "translate(0.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dollies",
    transform: "translate(960.000000, 533.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dolly",
    transform: "translate(87.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.25,4.85714286 L135.009676,4.85714286 C136.297208,4.85714286 137.35085,5.85928411 137.433081,7.12604438 L137.438248,7.28571429 L137.438248,14.5714286 C137.438248,15.3207363 137.092931,16.024519 136.508548,16.48269 L136.357533,16.592 L129.071819,21.4491429 C128.72939,21.6765612 128.336111,21.8132055 127.928684,21.8481791 L127.723962,21.8571429 L117.791105,21.8571429 C116.762301,27.9744107 111.969515,32.7671964 105.852248,33.796 C98.0296912,35.1117425 90.616294,29.9235092 89.1412134,22.1686949 L89.0853904,21.8571429 L64.7885756,21.8571429 L63.6,9.71428571 L57.3733762,9.71428571 L54.25,4.85714286 L135.009676,4.85714286 Z M103.438248,9.71428571 C98.0732297,9.71428571 93.7239618,14.0635536 93.7239618,19.4285714 C93.7239618,24.7935893 98.0732297,29.1428571 103.438248,29.1428571 C108.803265,29.1428571 113.152533,24.7935893 113.152533,19.4285714 C113.152533,14.0635536 108.803265,9.71428571 103.438248,9.71428571 Z M105.866819,17 L105.866819,21.8571429 L101.009676,21.8571429 L101.009676,17 L105.866819,17 Z M56.566819,17 L56.566819,21.8571429 L51.7096761,21.8571429 L51.7096761,17 L56.566819,17 Z M92.5873904,9.71428571 L65.0575679,9.71428571 C65.8277075,10.5684527 66.5081419,11.4981772 67.0988709,12.5034592 C67.650218,13.4417225 68.1438456,14.8099355 68.579754,16.6080985 L68.6722794,17 L89.0683904,17 C89.0805333,16.9368571 89.1145333,16.8785714 89.1145333,16.8178571 C89.2207833,16.211625 89.3671047,15.6126786 89.5516761,15.0255714 C89.5759618,14.9478571 89.6075333,14.8774286 89.631819,14.8021429 C89.8042476,14.2918393 90.0055154,13.7915536 90.2341047,13.3037143 C90.3021047,13.158 90.3701047,13.0147143 90.4429618,12.8714286 C90.6394485,12.4770893 90.853694,12.0921417 91.0850581,11.7174824 L91.3221047,11.3462857 L91.348819,11.3025714 C91.6900333,10.8050179 92.0613011,10.3290179 92.4611047,9.877 C92.5096761,9.826 92.5412476,9.76528571 92.5873904,9.71428571 Z M132.581105,9.71428571 L114.29639,9.71428571 C114.342533,9.76528571 114.378962,9.826 114.422676,9.877 C114.722529,10.2157857 115.00633,10.5684029 115.27344,10.9334428 L115.534962,11.3025714 L115.561676,11.3462857 C115.885283,11.8365536 116.178837,12.3456429 116.440819,12.8714286 C116.513676,13.0147143 116.581676,13.158 116.649676,13.3037143 C116.878265,13.7915536 117.079533,14.2918393 117.251962,14.8021429 C117.276248,14.8774286 117.307819,14.9478571 117.332105,15.0255714 C117.51698,15.6126786 117.662998,16.211625 117.769248,16.8178571 L117.792319,16.9080179 L117.792319,16.9080179 L117.81539,17 L126.99539,17 L132.581105,13.2721429 L132.581105,9.71428571 Z",
    id: "Combined-Shape",
    fill: "#f00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#f00",
    strokeWidth: 5.1,
    cx: 54.25,
    cy: 19.55,
    r: 11.9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#f00",
    x: 135,
    y: 5.1,
    width: 11.9,
    height: 5.1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#f00",
    points: "0.7 -2.76096606e-13 65.0575679 4.85714286 65.0575679 9.71428571 0.7 4.85714286"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#f00",
    transform: "translate(26.218626, 9.583968) rotate(1.000000) translate(-26.218626, -9.583968) ",
    points: "4.1 7.51079355 48.3372511 6.8 48.3372511 11.6571429 4.1 12.3679364"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#f00",
    transform: "translate(21.991235, 15.686447) rotate(1.000000) translate(-21.991235, -15.686447) ",
    points: "0.703242758 11.2008877 43.2792265 15.314864 43.2792265 20.1720068 0.703242758 16.0580305"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#f00",
    transform: "translate(144.350000, 11.050000) rotate(-270.000000) translate(-144.350000, -11.050000) ",
    points: "138.4 8.5 150.3 8.5 150.3 13.6 138.4 13.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#f00",
    transform: "translate(3.250000, 11.050000) rotate(-270.000000) translate(-3.250000, -11.050000) ",
    points: "-7.38006467 8.5 14.3 8.5 14.3 13.6 -7.8 13.6"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDollyRojo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dolly_rojo.efa88e0f.svg";
export { ForwardRef as ReactComponent };